<script>
/**
 * @file 我的资料
 */
import Confirm from './confirm';
import mixin from './mixins_api';

export default {
    mixins: [mixin],
    components: {
        Confirm
    },
    filters: {
        //  0 未设置 1产前 2 产后
        statusFormat(value) {
            const obj = {
                '0': '未设置',
                '1':  '产前',
                '2': '产后'
            };
            return obj[value];
        }
    },
    created() {
        this.getUserDetail().then(resp => {
            this.userInfo = resp.result || {};
        });
    },
    methods: {
        goback() {
            this.$router.push({
                name: 'my-center'
            });
        },
        toggleStatus(status) {
            this.status = status;
            this.closeSelectBox();
        },
        showSelectBox() {
            this.isShowSelectBox = true;
        },
        closeSelectBox() {
            console.log('closeSelectBox');
            this.isShowSelectBox = false;
        },
        handleOk() {
            this.isShowLogout = false;
        },
        handleCancel() {
            this.isShowLogout = false;
        }
    },
    data() {
        return {
            isShowLogout: false,
            isShowSelectBox: false,
            status: 'mother-to-be',
            userInfo: {}
        };
    }
};
</script>

<template lang="pug">
.forkiss-my-userinfo-container
    .my-userinfo-container
        .my-userinfo-header 我的资料
            .back-btn(@click="goback", data-touch="true")
        .info-box
            label 姓名
            span {{userInfo.realname}}
        .info-box
            label 手机
            span {{userInfo.mobile}}
        .info-box
            label 身份
            //- span.right-arrow(@click="showSelectBox") {{status | statusFormat}}
            span {{userInfo.stage | statusFormat}}
        //- button.my-userinfo-footer(@click="isShowLogout = true", data-touch="true") 退出登录
    //- .status-select-box(v-show="isShowSelectBox")
    //-     .select-box-mask(@click="closeSelectBox")
    //-     .select-container
    //-         ul.select-wrapper
    //-             li(:class="{active: status === 'mother-to-be'}",
    //-                 @click="toggleStatus('mother-to-be')") 准妈妈
    //-             li(:class="{active: status === 'mother'}",
    //-                 @click="toggleStatus('mother')") 宝妈
    Confirm(:show="isShowLogout", message="确定退出登录？", @ok="handleOk",
        @close="handleCancel")

</template>
<style lang="less" scoped>
.forkiss-my-userinfo-container {
    position: relative;
    font-size: .24rem;
    background: #FFF;
    padding-bottom: 1.16rem;
    color: #333;

    .my-userinfo-header {
        position: relative;
        height: .9rem;
        line-height: .9rem;
        font-size: .36rem;
        text-align: center;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
    }
    .back-btn {
        position: absolute;
        z-index: 22;
        top: 50%;
        left: .2rem;
        transform: translateY(-50%);
        width: .2rem;
        height: .36rem;
        background-image: url(../assets/back-black.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .info-box {
        position: relative;
        height: 1.24rem;
        line-height: 1.24rem;
        padding: 0 .3rem;

        &::after {
            content: "";
            position: absolute;
            right: .3rem;
            left: .3rem;
            bottom: 0;
            height: 1px;
            background: #EEE;

        }
        label {
            font-size: .32rem;
        }

        span {
            float: right;
            font-size: .28rem;
            color: #999999;

            &.right-arrow {

                &::after {
                    content: "";
                    display: inline-block;
                    vertical-align: middle;
                    width: .16rem;
                    height: .28rem;
                    margin-left: .15rem;
                    background-image: url(../assets/center-arrow.png);
                    background-repeat: no-repeat;
                    background-size: contain;
                }

            }
        }
    }

    .my-userinfo-footer {
        position: fixed;
        z-index: 1;
        width: 5.9rem;
        height: .96rem;
        left: 50%;
        bottom: .86rem;
        transform: translateX(-50%);
        margin: 0 auto;
        border: none;
        border-radius: .5rem;
        line-height: .96rem;
        color: #FFF;
        background: #c3a07b;
        font-size: .36rem;
        outline: none;
    }

    .status-select-box {
        position: relative;

        .select-box-mask {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 2;
            background: rgba(0, 0, 0, .6);
        }

        .select-container {
            position: fixed;
            right: 0;
            bottom: 0;
            left: 0;
            height: 2.56rem;
            z-index: 3;
        }

        .select-wrapper {
            position: absolute;
            width: 100%;
            bottom: 0;
            list-style: none;
            margin: 0;
            padding: 0;

            li {
                display: block;
                height: 1.28rem;
                line-height: 1.28rem;
                background: #FFF;
                font-size: .28rem;
                color: #666;
                text-align: center;

                &.active {
                    background: #EEE;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/my-userinfo.vue